import { environnement } from "configs/environnement";
import api from "./api";
import {
  ITrainingResponseDTO,
  ISaveTrainingDTO,
  IUpdateTrainingDTO,
} from "models/church.types"; // Ajustez le chemin vers vos types si nécessaire

const BASE_URL = `${environnement.baseURL}/trainings`;

export const TrainingService = {
  getAll: async (page: number, size: number) => {
    const response = await api.get<ITrainingResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
          query: "", // Paramètre de recherche vide pour tout lister
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  create: async (training: ISaveTrainingDTO): Promise<ITrainingResponseDTO> => {
    const response = await api.post<ITrainingResponseDTO>(
      `${BASE_URL}`,
      training,
    );
    return response.data;
  },

  update: async (
    training: IUpdateTrainingDTO,
  ): Promise<ITrainingResponseDTO> => {
    const response = await api.put<ITrainingResponseDTO>(
      `${BASE_URL}`,
      training,
    );
    return response.data;
  },

  getById: async (id: number): Promise<ITrainingResponseDTO> => {
    const response = await api.get<ITrainingResponseDTO>(`${BASE_URL}/${id}`);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  search: async (query: string, page: number, size: number) => {
    const response = await api.get<ITrainingResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
